// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
import './helper'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { BAlert } from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
import VueLodash from 'vue-lodash'
import lodash  from 'lodash';
import VueMoment from 'vue-moment'
import App from './App'
import CripLoading from "crip-vue-loading"
import { setupCalendar, DatePicker } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import {ClientTable, ServerTable, Event} from 'vue-tables-2'
import vSelect from 'vue-select'
import router from './router/index'
import store from './store'
import VueMonthlyPicker from 'vue-monthly-picker'
import VueHtmlToPaper from 'vue-html-to-paper';

const htmlToPrintoptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=no'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',

  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
}

Vue.use(VueAxios, axios)
Vue.use(CripLoading, {axios, color: "#32CD32"})
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueLodash,{ name: 'custom' , lodash: lodash })
Vue.use(VueMoment)
Vue.component('v-select', vSelect)
Vue.use(ClientTable)
Vue.use(ServerTable)
Vue.use(VueMonthlyPicker)
Vue.use(VueHtmlToPaper,htmlToPrintoptions)

Vue.component('b-alert', BAlert)
import VueNumberInput from '@chenfengyuan/vue-number-input'
Vue.use(VueNumberInput)
Vue.component('v-date-picker', DatePicker)
Vue.component('vue-monthly-picker', VueMonthlyPicker)
setupCalendar({
  firstDayOfWeek: 2 // Monday
})

Vue.axios.defaults.baseURL= process.env.VUE_APP_API_URL
Vue.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
}

Vue.router = router;

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'permissions',
  loginData: {url: 'auth/login', fetchUser: false},
  fetchData: {url: 'auth/user'},
  refreshData: {url: 'auth/refresh'},
  parseUserData: function(data) {
    return data.data || {}
  }
})

import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
//  VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})
